/**
 * Helper functions for RekAI filtering
 *
 * Usage filters: subtree, excludetree
 * Both subtree and excludetree are handled differently depending on if slash is added to ending or not.
 * When slash is added to the end, all subpages under that url will be included or excluded
 * When slash is missing at the end, any page which matches that url will be included or excluded
 * Make sure all urls start with a slash
 * According to RekAI documentation, a value can start with "!" (for excludetree) or "^" (for subtree) to match exactly
 *
 * https://docs.rek.ai/advanced/allparameters/filter-parameters/excludetree
 * https://docs.rek.ai/advanced/allparameters/filter-parameters/subtree
 */

const getPath = (str) => {
    if (!str) {
        return str;
    }
    if (typeof str === 'object' || str === null) return null;

    // Remove the special characters for matching exactly, and readd before return
    const specialChars = /^[!^]+/;
    const prefix = str.match(specialChars)?.[0] || '';
    let path = str.slice(prefix.length);

    try {
        const url = new URL(path);
        path = url.pathname;
    } catch (error) {
        // String is not an url, so just allow it as is
    }
    const formattedPath = path.startsWith('/') ? path : `/${path}`;
    return `${prefix}${formattedPath}`;
};

const getRekAITreeFromUrls = (field) => {
    if (!field) {
        return null;
    }

    return Array.isArray(field) ? field.map(getPath).join(',') : getPath(field);
};

const getRekAIParams = ({ subtree = null, excludetree = null, ...restProps }) => {
    return {
        ...restProps,
        ...(subtree && { subtree: getRekAITreeFromUrls(subtree) }),
        ...(excludetree && { excludetree: getRekAITreeFromUrls(excludetree) }),
    };
};

const constructLdjsonfilterParams = (filter) => {
    if (!filter || typeof filter !== 'object') {
        return {};
    }

    return Object.entries(filter).reduce((acc, [key, value]) => {
        acc[`ldjsonfilter.${key}`] = value;
        return acc;
    }, {});
};

export { constructLdjsonfilterParams, getRekAITreeFromUrls, getRekAIParams };
